import { render, staticRenderFns } from "./SizeSwitch.vue?vue&type=template&id=02b40914"
import script from "./SizeSwitch.vue?vue&type=script&lang=js"
export * from "./SizeSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports